<template>
  <div class="mobileBottomCtn">
    <div class="title">用人工智能，改变环卫未来！</div>
    <div class="content">服务热线：18897777730</div>
    <el-menu class="el-menu-vertical-demo" router background-color="#000b12" text-color="#fff">
      <el-menu-item index="/mobile/home">
        <template slot="title">
          <div class="label">首页</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/xietong">
        <template slot="title">
          <div class="label">协同平台</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/chanping">
        <template slot="title">
          <div class="label">产品中心</div>
        </template>
      </el-menu-item>
      <el-submenu index="3">
        <template slot="title">
          <div class="label">产品列表</div>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/mobile/productA">室内清洁机器人小普SN300</el-menu-item>
          <el-menu-item index="/mobile/productB">室内清洁机器人小普SN200</el-menu-item>
          <el-menu-item index="/mobile/productC">室外清洁机器人小普PS100</el-menu-item>
          <el-menu-item index="/mobile/productD">室外清洁机器人小普PS200</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/mobile/about">
        <template slot="title">
          <div class="label">关于博城</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/fuwu">
        <template slot="title">
          <div class="label">服务案例</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/contact">
        <template slot="title">
          <div class="label">联系我们</div>
        </template>
      </el-menu-item>
    </el-menu>
    <div class="icp">
      <img :src="require('@/assets/images/logo01.dd7ff50e.png')" />
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备2025156222号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mobilebottom',
  methods: {
    getMenu() { }
  }
}
</script>

<style lang="scss" scoped>
.mobileBottomCtn {
  background: #000b12;

  .title {
    line-height: 60px;
    font-size: 22px;
    color: #95F204;
    padding: 0 20px;
    font-weight: bold;
  }

  .content {
    color: #fff;
    line-height: 26px;
    margin: 12px 0;
    padding: 0 20px;
  }

  .icp {
    text-align: center;
    padding: 20px 0;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      color: #fff !important;
      text-decoration: none;
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
}
</style>